import { all } from 'redux-saga/effects'
import alert from './components/Alert/Alert.effects'
import confirm from './components/Confirm/Confirm.effects'
import progressBar from './components/ProgressBar/ProgressBar.effects'
import labelBuilder from './views/LabelBuilder/LabelBuilder.effects'
import workOrderCalendar from './views/WorkOrderCalendar/WorkOrderCalendar.effects'
import items from './views/Items/Items.effects'
import workOrders from './views/WorkOrders/WorkOrders.effects'
import receivings from './views/Receivings/Receivings.effects'
import inventories from './views/Inventories/Inventories.effects'
import barePallets from './views/BarePallets/BarePallets.effects'
import shipOrders from './views/ShipOrders/ShipOrders.effects'
import purchaseOrders from './views/PurchaseOrders/PurchaseOrders.effects'
import billsOfLading from './views/BillsOfLading/BillsOfLading.effects'
import standaloneCases from './views/StandaloneCases/StandaloneCases/StandaloneCases.effects'
import consumedCases from './views/StandaloneCases/ConsumedCases/ConsumedCases.effects'
import packTraces from './views/PackTraces/PackTraces.effects'
import customLabels from './views/CustomLabels/CustomLabels.effects'
import systemLabels from './views/SystemLabels/SystemLabels.effects'
import customLabelPrintsPaginate from './views/CustomLabelPrintsPaginate/CustomLabelPrintsPaginate.effects'

export function * effects () {
  yield all([
    alert(),
    confirm(),
    progressBar(),
    labelBuilder(),
    workOrderCalendar(),
    items(),
    workOrders(),
    receivings(),
    inventories(),
    barePallets(),
    billsOfLading(),
    shipOrders(),
    purchaseOrders(),
    standaloneCases(),
    consumedCases(),
    packTraces(),
    customLabels(),
    systemLabels(),
    customLabelPrintsPaginate()
  ])
}
